import { render, staticRenderFns } from "./config-list.vue?vue&type=template&id=026a2df2&"
import script from "./config-list.vue?vue&type=script&lang=js&"
export * from "./config-list.vue?vue&type=script&lang=js&"
import style0 from "./config-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "config-list.vue"
export default component.exports